import styled from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        padding: 32px 0;
    `,
    "Area": styled.div`
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${({ theme }) => theme.color["grey2"]};
        padding: 32px 24px 0 24px;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["large-medium"]};
        }

        & > p {
            ${({ theme }) => theme.font["large-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
    "BtnDiv": styled.div`
        padding: 32px 24px 0 24px;
    `,
}